<template>
  <div class="logo2" :style="{ backgroundImage: `url(${image})` }"></div>
</template>

<script>
export default {
  props: ['image'],
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
.logo2 {
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;
  background-origin: border-box;
}
</style>
